import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import { EMPTY_OBJECT } from './AddTaskList'

function UpdateCube(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [databaseId, setDatabaseId] = useState(-1)
    const [dataSourceSystemName, setDataSourceSystemName] = useState('')
    const [databaseName, setDatabaseName] = useState('')
    const [sqLDbList, setSqLDbList] = useState([])
    const [dataSources, setDataSources] = useState([])
    const [ssasServers, setSsasServers] = useState([])
    const [selectedSsasServer, setSelectedSsasServer] = useState(-1)
    const [ssasDataSources, setSsasDataSources] = useState([])
    const [selectedSsasDataSource, setSelectedSsasDataSource] = useState('')
    const [selectedSsasDataSourceCubeName, setSelectedSsasDataSourceCubeName] = useState('')

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        if (ssasServers.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 1)
            setSsasServers(dBList)
        }
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            if (props.taskData.databaseId !== databaseId) {
                setIsLoadingRequest(true)
                setDatabaseId(props.taskData.databaseId)

                let getDataSources = props.getDataSources(props.taskData.databaseId)
                getDataSources.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    setDataSources(json)
                    setIsLoadingRequest(true)
                    setDataSourceSystemName(props.taskData.dataSourceSystemName)
                    
                    if (props.taskData.originDatabaseId && props.taskData.originDatabaseId > -1) {
                        setIsLoadingRequest(true)
                        setSelectedSsasServer(props.taskData.originDatabaseId)
                        let getDataSources = props.getDataSources(props.taskData.originDatabaseId)
                        getDataSources.then((resp) => { 
                            if (resp.status !== 200) {
                                throw new Error(resp)
                            } else {
                                return resp.json()
                            }
                        }).then((json) => {
                            setIsLoadingRequest(false)
                            setSsasDataSources(json)
                            setSelectedSsasDataSource(props.taskData.originDatabaseDataSourceSystemName)
                            setSelectedSsasDataSourceCubeName(props.taskData.dataSourceName)
                        }).catch((ex) => {
                            console.error(ex)
                            setIsLoadingRequest(false)
                            setSsasDataSources([])
                            setSelectedSsasServer(-1)
                            setSelectedSsasDataSource('')
                            setSelectedSsasDataSourceCubeName('')
                        })
                    }
            }).catch((ex) => {
                console.error(ex)
                setDataSources([])
                setIsLoadingRequest(false)
            })

            setDatabaseName(props.taskData.databaseName)
            }
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceSystemName('')

            if (props.taskData.originDatabaseId && props.taskData.originDatabaseId > -1) {
                setIsLoadingRequest(true)
                setSelectedSsasServer(props.taskData.originDatabaseId)
                let getDataSources = props.getDataSources(props.taskData.originDatabaseId)
                getDataSources.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    setIsLoadingRequest(false)
                    setSsasDataSources(json)
                    setSelectedSsasDataSource(props.taskData.originDatabaseDataSourceSystemName)
                    setSelectedSsasDataSourceCubeName(props.taskData.dataSourceName)
                }).catch((ex) => {
                    console.error(ex)
                    setIsLoadingRequest(false)
                    setSsasDataSources([])
                    setSelectedSsasServer(-1)
                    setSelectedSsasDataSource('')
                    setSelectedSsasDataSourceCubeName('')
                })
            }
        }
    }, [props.taskData.databaseId, props.taskData.dataSourceSystemName, props.taskData.originDatabaseId, props.taskData.originDatabaseDataSourceSystemName, props.taskData.dataSourceName, props.taskData.databaseName])

    function handleDatabase(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setDataSourceSystemName('')
        setIsLoadingRequest(true)
        setDataSources([])
        setDatabaseName('')

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            let dbName = ''
            sqLDbList.forEach(db => {
                if (db.id === event.target.value) {
                    setDatabaseName(db.dBname)
                    dbName = db.dBname
                }
            })
            setDataSources(json)
            setIsLoadingRequest(false)
            fireOnSaveEvent(event.target.value, dbName, "", selectedSsasServer, selectedSsasDataSource, selectedSsasDataSourceCubeName)
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setIsLoadingRequest(false)
        })
    }

    function handleDataSourceChange(event) {
        event.preventDefault()
        setDataSourceSystemName(event.target.value)

        dataSources.forEach((ds) => {
            if (ds.key === event.target.value) {
                fireOnSaveEvent(databaseId, databaseName, event.target.value, selectedSsasServer, selectedSsasDataSource, selectedSsasDataSourceCubeName)
            }
        })
    }

    function handleSsasServer(event) {
        event.preventDefault()
        setIsLoadingRequest(true)
        setSelectedSsasServer(event.target.value)

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setIsLoadingRequest(false)
            setSsasDataSources(json)
            fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, event.target.value, '', '')
        }).catch((ex) => {
            console.error(ex)
            setIsLoadingRequest(false)
            setSsasDataSources([])
            setSelectedSsasServer('')
        })
    }

    function handleSsasDataSourceChange(event) {
        event.preventDefault()
        setSelectedSsasDataSource(event.target.value)
        
        let lookup = null
        for (let x = 0; x < ssasDataSources.length; x++) {
            if (ssasDataSources[x]["key"] === event.target.value) {
                lookup = ssasDataSources[x]
            }
        }

        if (lookup !== null) {
            setSelectedSsasDataSourceCubeName(lookup["value"])
            fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, selectedSsasServer, lookup["key"], lookup["value"])
        }
    }

    /**
     * fireOnSaveEvent
     * * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} dsSystemName - Data source system name from the selected database
     * @param {int} ssasServerId - SSAS Server From Database
     * @param {string} ssasCubeId - Cube ID
     * @param {string} cubeName - Cube Name
     */
    function fireOnSaveEvent(dbId, dbName, dsSystemName, ssasServerId, ssasCubeId, cubeName) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceSystemName"] = dsSystemName
            copied["dataSourceName"] = cubeName
            copied["originDatabaseId"] = ssasServerId
            copied["originDatabaseDataSourceSystemName"] = ssasCubeId
            props.onSave(copied)
        }
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Update Cube</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-databse-label">Select Database</InputLabel>
                <Select
                    labelId="select-databse-label"
                    id="select-databse"
                    label="Select Database"
                    onChange={handleDatabase}
                    defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                    value={databaseId}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select Database</MenuItem>
                        { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-data-source-label">Select Data Source</InputLabel>
                <Select
                    labelId="select-data-source-label"
                    id="select-data-source"
                    label="Select Data Source"
                    onChange={handleDataSourceChange}
                    value={dataSourceSystemName}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={''}>Select Data Source</MenuItem>
                        { dataSources.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>) }
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-ssas-database-server-label">SSAS Database Server</InputLabel>
                <Select
                    labelId="select-ssas-database-server-label"
                    id="select-ssas-database-server"
                    label="SSAS Database Server"
                    onChange={handleSsasServer}
                    defaultValue={ssasServers.length > 0 ? ssasServers[0].id : -1}
                    value={selectedSsasServer}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select SSAS Database Server</MenuItem>
                        { ssasServers.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-ssas-database-label">SSAS Cube</InputLabel>
                <Select
                    labelId="select-ssas-database-label"
                    id="select-ssas-database"
                    label="Select SSAS Data Source"
                    onChange={handleSsasDataSourceChange}
                    value={selectedSsasDataSource}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={''}>Select SSAS Data Source</MenuItem>
                        { ssasDataSources.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>) }
                </Select>
            </FormControl>
        </Paper>
    )
}

export default UpdateCube